module.exports = __webpack_public_path__ + "img/zsofi.016835ae.jpg";